import create from "zustand";

export interface Order {
  address?: string;
  asset: string;
  amount: number;
  type: string;
  currency: string;
  walletType?: string;
}

export interface Payment {
  type: string;
  network?: string;
  accountType?: string;
  mobileMoneyNumber?: string;
  accountName?: string;
  bank?: string;
  branch?: string;
  accountNumber?: string;
}
export type State = {
  order: Order;
  payment: Payment;
  logoutLoading: boolean;
  fetchedUserOrderState: any;
  sideBarState: boolean;
  fullScreenModalState: boolean;
  orderModalState: boolean;
  addOrder: (order: Order) => void;
  addPayment: (payment: Payment) => void;
  setFetchedUserOrderState: (order: any) => void;
  setLogoutLoading: (loading: boolean) => void;
  setSideBarState: (action: boolean) => void;
  setFullScreenModalState: (action: boolean) => void;
  setOrderModalState: (action: boolean) => void;
};
export const useStore = create<State>((set) => ({
  logoutLoading: false,
  order: {
    address: "",
    asset: "",
    amount: 0.0,
    type: "",
    currency: "",
  },
  payment: {
    type: "",
    network: "MTN",
    accountType: "Subscriber",
    mobileMoneyNumber: "",
    accountName: "",
    bank: "",
    branch: "",
    accountNumber: "",
  },
  fetchedUserOrderState: {},
  sideBarState: false,
  fullScreenModalState: false,
  orderModalState: false,
  addOrder: (order) => set(() => ({ order: order })),
  addPayment: (payment) => set(() => ({ payment: payment })),
  setLogoutLoading: (loading) => set(() => ({ logoutLoading: loading })),
  setFetchedUserOrderState: (order) =>
    set(() => ({ fetchedUserOrderState: order })),
  setSideBarState: (action) => set(() => ({ sideBarState: action })),
  setFullScreenModalState: (action) =>
    set(() => ({ fullScreenModalState: action })),
  setOrderModalState: (action) => set(() => ({ orderModalState: action })),
}));
